export { IN_PROGRESS_STATUSES, POLL_INTERVAL_MS, POLL_TIMEOUT_MS } from "./CrmBulkUpload.constants";

// The full set of supplier formats the backend can parse. This is the
// authoritative list from the backend handover doc, not SIA's legacy
// desktop dropdown, which omitted "Stark" despite the backend supporting it.
export const supplierOptions: string[] = [
  "BG Lite",
  "British Gas Business",
  "Corona Energy",
  "Drax",
  "E.ON",
  "EDF",
  "gdf suez Engie",
  "NPower",
  "Positive Energy",
  "Power NI",
  "SEFE Energy",
  "SSE",
  "Stark",
  "TEM Energy",
  "Total Energies",
  "UB",
  "UD",
];

export const ACCEPTED_FILE_EXTENSIONS = ".xlsx,.xls,.csv,.pdf";

// Colour used to render each output log level. Anything not listed here
// (an unrecognised level from the backend) falls back to the DEBUG colour.
export const LOG_LEVEL_COLORS: Record<string, string> = {
  DEBUG: "#000000",
  INFO: "#1a7f37",
  WARNING: "#c0341d",
  WARN: "#c0341d",
  ERROR: "#c0341d",
  CRITICAL: "#c0341d",
};

// API Gateway caps the request body at 10MB and base64 inflates raw bytes
// by roughly a third, so reject oversized source files client-side rather
// than letting the call fail server-side.
export const MAX_FILE_SIZE_BYTES = 7 * 1024 * 1024;
